import { Component } from '@angular/core';

@Component({
  selector: 'app-cards-9',
  templateUrl: './cards-9.component.html'
})
export class Cards9Component {



    }
